import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { Spacing } from '../../design-system/spacing';
import { Kind } from '../../types/kind';
import { styled } from '../../utils/styled';
import { Box } from '../Box';
import { Stack } from '../Stack';

export const ItemWrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>`
  width: 100%;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing(Spacing.Small)};
  color: ${({ color }) => color};
  height: 50px;
  flex-direction: row;
`;

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>`
  margin-right: ${({ theme }) => theme.spacing(Spacing.Large)};
  color: ${({ color }) => color};
  width: 30px;
  display: flex;
  justify-content: center;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
`;

export const NavItemWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: Kind }>`
  white-space: nowrap;
  background-color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.background.dark
      : theme.palette.background.paper};
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  border-radius: ${({ theme }) => theme.borderRadii.outer};
  color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.text.secondaryInverted
      : theme.palette.text.secondary};

  &:hover {
    background-color: ${({ theme, kind }) =>
      kind === 'dark' ? theme.palette.neutral[800] : theme.palette.paper[400]};
  }
  width: 85%;
`;

export const StyledAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: Kind }>`
  background-color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.background.dark
      : theme.palette.background.paper};
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  padding: ${({ theme }) => theme.spacing(Spacing.Small)};
  border-radius: ${({ theme }) => theme.borderRadii.outer};
  color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.text.secondaryInverted
      : theme.palette.text.secondary};

  &:hover {
    background-color: ${({ theme, kind }) =>
      kind === 'dark' ? theme.palette.neutral[800] : theme.palette.paper[400]};
  }
`;

export const AccordionLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;

  &:first-of-type > div {
    border-top-left-radius: ${({ theme }) => theme.borderRadii.outer};
    border-top-right-radius: ${({ theme }) => theme.borderRadii.outer};
  }
  &:last-child > div {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadii.outer};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadii.outer};
  }
`;

export const AccordionInnerItems = styled('div', {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: Kind }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ theme, kind }) =>
    kind === 'dark' ? theme.palette.neutral[900] : theme.palette.paper[200]};
  color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.text.secondaryInverted
      : theme.palette.text.secondary};
  padding: ${({ theme }) => theme.spacing(Spacing.Small)};
  ${({ theme }) => theme.spacing(Spacing.Medium)};

  &:hover {
    background-color: ${({ theme, kind }) =>
      kind === 'dark' ? theme.palette.neutral[800] : theme.palette.paper[400]};
  }
`;

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: Kind }>`
  box-shadow: none;
  width: 100%;
  background-color: transparent;

  color: ${({ theme, kind }) =>
    kind === 'dark'
      ? theme.palette.text.secondaryInverted
      : theme.palette.text.secondary};

  &::before {
    opacity: 0;
  }

  &:hover {
    border-radius: ${({ theme }) => theme.borderRadii.outer};
  }

  &.Mui-expanded {
    margin: 0;
  }

  & .MuiAccordionSummary-expandIconWrapper {
    color: ${({ theme, kind }) =>
      kind === 'dark'
        ? theme.palette.text.secondaryInverted
        : theme.palette.text.secondary};
  }
  & .MuiAccordionSummary-root,
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 40px;
  }
  & .MuiAccordionSummary-content,
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  & .MuiAccordionDetails-root {
    padding: 0;
  }
`;
